import React from 'react';
import './progress-component.scss';

interface ProgressComopnentProps {
    message: string;
    width?: number | string; // e.g. 420 or "100%"
    variant?: 'indeterminate' | 'determinate';
    value?: number; // 0–100 (used only for determinate)
}

const ProgressComopnent: React.FC<ProgressComopnentProps> = ({ message, width = 420, variant = 'indeterminate', value = 0 }) => {
    const pct = Math.max(0, Math.min(100, value));

    return (
        <div className="isp__progress-component">
            <div
                className="progress-inline"
                style={{ width: typeof width === 'number' ? `${width}px` : width }}
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={variant === 'determinate' ? pct : undefined}
                aria-label={message}>
                <div className="message">{message}</div>

                <div className="track">
                    {variant === 'determinate' ? (
                        <div
                            className="fill"
                            style={{ width: `${pct}%` }}
                        />
                    ) : (
                        <div className="chunk" />
                    )}
                </div>
            </div>{' '}
        </div>
    );
};

export default ProgressComopnent;
